import React, { useEffect, useState } from "react";
import BarChart from "./BarChart";
import { article_dash, download_files } from "../api";
import LoadingScreen from "react-loading-screen";
import Dashboardtable from "./Dashboardtable";
import Dashboardgraph from "./Dashboardgraph";
import Histogramchart from "./Histogramchart";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Dashboardlayout = () => {
  const [data, setData] = useState([]);
  const [datatomap, setDataToMap] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tabledata, setTableData] = useState([]);
  const [bargraph, setBargraph] = useState([]);
  const [histogram, setHistogram] = useState();
  const [tablegroup, setTablegroup] = useState();
  const [figuregroup, setFiguregroup] = useState();
  const [toggleInfo, setToggleInfo] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchreport();
  }, []);

  let fetchreport = async () => {
    const TIMEOUT = 60000; // 60 seconds
    const timeoutPromise = new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Timeout")), TIMEOUT)
    );
    try {
      const result = await Promise.race([article_dash(), timeoutPromise]);

      if (result.data) {
        setLoading(false);
        setData(result.data || []);
      } else {
        console.log(result.error);
        setLoading(false);
        toast.error(result.error.message);
      }
    } catch (e) {
      if (e.message === "Timeout") {
        toast.warn("Response took longer than expected, Redirecting ...");
        navigate("/uploadfiles"); // Replace with your timeout page route
      } else {
        console.log(e?.response?.data?.message || e.message);
      }
    }
  };
  // console.log(data);

  useEffect(() => {
    if (data.length > 0) {
      let filteredData = data?.filter((items) =>
        [10, 11, 15, 27, 6, 9, 23, 41].includes(items.c_id)
      );
      setTableData(filteredData);
      let bardata = data?.filter((items) => [1, 2, 18].includes(items.c_id));
      setBargraph(bardata);
      let histogramdata = data?.filter((items) => [36].includes(items.c_id));
      setHistogram(histogramdata);
    }
  }, [data]);

  console.log(tabledata);
  // Data for donut chart
  useEffect(() => {
    if (data.length > 0) {
      const filteredData = data?.filter(
        (item) =>
          "article" in item &&
          Array.isArray(item.article) &&
          item.article.some((articleItem) => articleItem.count !== 0) &&
          ![
            10, 11, 15, 27, 6, 8, 37, 38, 39, 40, 1, 2, 18, 28, 9, 23, 29, 36,
            14, 35, 34, 17, 12, 13,
          ].includes(item.c_id)
      );
      setDataToMap(filteredData);
    }
  }, [data]);
  // Table citation group donut chart
  useEffect(() => {
    if (data.length > 0) {
      const filteredData = data?.filter(
        (item) =>
          "article" in item &&
          Array.isArray(item.article) &&
          item.article.some((articleItem) => articleItem.count !== 0) &&
          [14, 35, 34].includes(item.c_id)
      );
      setTablegroup(filteredData);
    }
  }, [data]);

  // Figure citation group donut chart
  useEffect(() => {
    if (data.length > 0) {
      const filteredData = data?.filter(
        (item) =>
          "article" in item &&
          Array.isArray(item.article) &&
          item.article.some((articleItem) => articleItem.count !== 0) &&
          [17, 12, 13].includes(item.c_id)
      );
      setFiguregroup(filteredData);
    }
  }, [data]);

  // const handleDownload = async () => {
  //   try {
  //     const result = await download_files();
  //     if (result) {
  //       const blob = await result.blob;
  //       let url = window.URL.createObjectURL(blob);
  //       let link = document.createElement("a");
  //       link.href = url;
  //       link.download = "files.zip";
  //       link.click();

  //       window.URL.revokeObjectURL(url);
  //     } else {
  //       throw new Error("Failed to Download files");
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  const handleDownload = async (state) => {
    // console.log(state);
    toast.info("Downloading files, please wait", {
      autoClose: false,
    });
    try {
      const result = await download_files(state); // Assuming this returns a Response object
      if (result.data) {
        toast.dismiss();
        toast.success("Files downloaded");
        const blob = new Blob([result.data]);
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.href = url;
        link.download = "files.zip";
        link.click();
        window.URL.revokeObjectURL(url);
      } else {
        toast.dismiss();
        toast.info("No files to download");
      }
    } catch (e) {
      toast.error("Error during download", e);
    }
  };

  const toggleinfo = () => {
    setToggleInfo(!toggleInfo);
  };

  return (
    <div className="w-full flex justify-center flex-col px-10 items-center pb-20">
      <div className="w-full flex flex-col md:flex-row md:justify-between items-center mt-12 mb-12">
        <div className="w-6/12 flex justify-start items-center">
          <p className="text-32 font-semibold">Integrity Dashboard</p>
        </div>
        <div className="w-fit flex gap-5 h-fit">
          <button
            onClick={() => handleDownload("true")}
            className="py-4 px-3 rounded-[12px] bg-[green] text-white"
          >
            Passed Files
          </button>
          <button
            onClick={() => handleDownload("false")}
            className="py-4 px-3 rounded-[12px] bg-[red] text-white"
          >
            Files Failed
          </button>
          <div
            className="relative h-[14px] w-[14px] hover:cursor-pointer"
            onMouseEnter={() => setToggleInfo(true)}
            onMouseLeave={() => setToggleInfo(false)}
          >
            <img src={process.env.PUBLIC_URL + "/images/info.png"} alt="info" />
            {toggleInfo && (
              <div className="absolute right-0 w-[300px] text-14 z-10 bg-white px-4 py-5">
                <p className="w-full text-[gray]">
                  The pass criteria is based on files having author department
                  relevance to journal and reference relevance to journal
                  results are true.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="w-full">
        <LoadingScreen
          loading={loading}
          bgColor="#f1f1f1"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          // logoSrc="/logo.png"
          text="Fetching Data please wait"
        >
          <div className="flex w-full p-5 border-[1px] border-[#f1f1f1]  mt-5">
            <Dashboardgraph data={bargraph} />
          </div>

          {/* Table group  */}
          {data.length > 0 && (
            <div className="w-full grid grid-cols-2 gap-5 p-5 border-[1px] border-[#f1f1f1] mt-5 ">
              {tablegroup?.map((item, i) => (
                <div
                  key={i}
                  className="w-full h-fit flex flex-col justify-between mt-[64px] rounded-[32px] relative "
                >
                  <div className="mx-10 my-10 absolute -top-20 z-5 text-18">
                    <p>{item.title}</p>
                  </div>

                  <div className="w-full">
                    <BarChart data={item.article} />
                  </div>
                </div>
              ))}
            </div>
          )}
          {/* Figure group */}
          {data.length > 0 && (
            <div className="w-full grid grid-cols-2 gap-5 p-5 border-[1px] border-[#f1f1f1] mt-5 ">
              {figuregroup?.map((item, i) => (
                <div
                  key={i}
                  className="w-full h-[400px] flex flex-col justify-between mt-[64px] rounded-[32px] relative "
                >
                  <div className="mx-10 my-10 absolute -top-20 z-5 text-18">
                    <p>{item.title}</p>
                  </div>

                  <div className="w-full">
                    <BarChart data={item.article} />
                  </div>
                </div>
              ))}
            </div>
          )}
          {/* Remaining donut chart data */}
          {data.length > 0 && (
            <div className="w-full grid grid-cols-2 gap-5 p-5 border-[1px] border-[#f1f1f1] mt-5 ">
              {datatomap.map((item, i) => (
                <div
                  key={i}
                  className="w-full h-[400px] flex flex-col justify-between mt-[64px] rounded-[32px] relative "
                >
                  <div className="mx-10 my-10 absolute -top-20 z-5 text-18">
                    <p>{item.title}</p>
                  </div>

                  <div className="w-full">
                    <BarChart data={item.article} />
                  </div>
                </div>
              ))}
            </div>
          )}
          {/* <div className="flex w-full p-5 border-[1px] border-[#f1f1f1] bg-[#f1f1f1] mt-5">
            {histogram && <Histogramchart data={histogram} />}
          </div> */}

          {data.length > 0 && (
            <div className="flex w-full p-5 border-[1px] border-[#f1f1f1] bg-[#f1f1f1] mt-5">
              <Dashboardtable data={tabledata} />
            </div>
          )}
        </LoadingScreen>
      </div>
    </div>
  );
};

export default Dashboardlayout;
